import { useMemo } from 'react';
import { useFetchUserInfo } from '../../userInfo/hooks/useFetchUserInfo';
export const useCurrentUser = () => {
  const {
    data,
    loading,
    error
  } = useFetchUserInfo();
  const currentUser = useMemo(() => {
    if (!data || !data.userInfo || !data.userInfo.user) {
      return undefined;
    }
    const user = data.userInfo.user;
    const firstName = user.first_name || '';
    const lastName = user.last_name || '';
    const displayName = [firstName, lastName].filter(Boolean).join(' ');
    return {
      id: user.user_id,
      email: user.email,
      displayName
    };
  }, [data]);
  return {
    loading,
    error,
    data: currentUser
  };
};